import type { CreateTagPayload } from '@domain/schemas/payload.schema';
import type { UpdateTagResponse } from '@responses/tags';
import axios from 'axios';

import { getRequestAuthPayload } from '../helpers/getRequestAuth';

export const updateTag = async (id: string, data: CreateTagPayload): Promise<UpdateTagResponse> => {
  const networkPayload = await getRequestAuthPayload({
    method: 'patch',
    url: `tags/${id}`,
    data,
  });

  const response = await axios(networkPayload);
  return response.data;
};
